import * as React from 'react';
import { Table } from '@backstage/core-components';

const columns = [
  {
    title: "cluster",
    width: "10%",
    render: (row) => row.cluster.title || row.cluster.name
  },
  {
    title: "namespace",
    width: "10%",
    render: (row) => row.error.sourceRef.namespace
  },
  {
    title: "kind",
    width: "10%",
    render: (row) => row.error.sourceRef.kind
  },
  {
    title: "name",
    width: "30%",
    render: (row) => {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, row.error.sourceRef.name, " ");
    }
  },
  {
    title: "messages",
    width: "40%",
    render: (row) => row.error.message
  }
];
const sortBySeverity = (a, b) => {
  if (a.error.severity < b.error.severity) {
    return 1;
  } else if (b.error.severity < a.error.severity) {
    return -1;
  }
  return 0;
};
const ErrorReporting = ({
  detectedErrors,
  clusters
}) => {
  const errors = Array.from(detectedErrors.entries()).flatMap(([clusterName, resourceErrors]) => {
    return resourceErrors.map((e) => ({
      cluster: clusters.find((c) => c.name === clusterName),
      error: e
    }));
  }).sort(sortBySeverity);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, errors.length !== 0 && /* @__PURE__ */ React.createElement(
    Table,
    {
      title: "Error Reporting",
      data: errors,
      columns,
      options: { paging: true, search: false, emptyRowsWhenPaging: false }
    }
  ));
};

export { ErrorReporting };
//# sourceMappingURL=ErrorReporting.esm.js.map
